import React from 'react';
import '../csscontainer/InfoBox.css'; // CSS file for styles

function InfoBox({ 
  imageSrc, 
  title, 
  description, 
  descriptionColor, // NEW PROP: Accepts a color string (e.g., '#FF0000', 'blue')
  showBorder = true 
}) {
  return (
    <div
      className={`info-box row-row-container-ib ${
        showBorder ? "with-border" : "no-border"
      }`}
    >
      {/* The image is the first item */}
      <img src={imageSrc} alt="Visual" className="info-image" />

      {/* The content wrapper is the second item */}
      <div className="info-content">
        <h2 className="info-title">{title}</h2>

        {/* Dynamic Style Application */}
        <p
          className="info-description"
          style={{ color: descriptionColor }} // Apply the color from the prop
        >
          {description}
        </p>
      </div>
    </div>
  );
}
export default InfoBox;